import { useCurrentUser } from 'hooks';
import { isIntegrationEnabled } from 'utils/email-integration-utils';

export const useIsIntegrationEnabled = () => {
  const { me } = useCurrentUser();

  return isIntegrationEnabled(me);
};
